import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue'
import { onBeforeRouteLeave, useRoute, useRouter } from 'vue-router'
import { eventCenter, event } from '@evideo/frontend-utils'
import { getSchoolTeacherCoursewareInfoByShareRecordId } from '@/services/audit-management'
import config from '@/config'
import PptEditor from '@/components/ppt-editor/PptEditor.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()

const recordId = route.params.recordId

const fileInfo = ref<any>({})

const pptEditor = ref()

const fileName = ref<string>('')

const url = ref(null)

const formData = ref('teacher')
const courseData = ref('')

const handleGoBack = () => {
  router.push('/content-center/audit-management/school')
}

onBeforeRouteLeave((to, from, next) => {
  eventCenter.send(event.COMMON_UNLOAD_MICRO_APP, {
    app: config.pptist.name
  })
  setTimeout(() => {
    next()
  }, 0)
})

onMounted(async () => {
  const data = await getSchoolTeacherCoursewareInfoByShareRecordId((recordId as string))
  url.value = data.url || ''
  fileName.value = data.name
  fileInfo.value = data
  console.log('=====', data)
  courseData.value = data.courseware_id
})


return (_ctx: any,_cache: any) => {
  const _component_a_page_header = _resolveComponent("a-page-header")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_page_header, {
      title: "预览课件",
      subTitle: fileName.value,
      style: {"background-color":"white"}
    }, {
      extra: _withCtx(() => [
        _createElementVNode("a", { onClick: handleGoBack }, "返回")
      ]),
      _: 1
    }, 8, ["subTitle"]),
    (courseData.value)
      ? (_openBlock(), _createBlock(PptEditor, {
          key: 0,
          resource: url.value,
          ref: (_value, _refs) => {
            _refs['pptEditor'] = _value
            pptEditor.value = _value
          },
          type: "preview",
          resourceType: "share",
          width: "100%",
          height: "90vh",
          autoHideMenu: true,
          from: formData.value
        }, null, 8, ["resource", "from"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})